import React from 'react'
import PropTypes from 'prop-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronRight } from '@fortawesome/free-solid-svg-icons'

import { useI18n } from 'context/i18n'

import * as S from './styles'

const ChatHeader = ({ title, chatListIsOpen, handleOpenChatList, unreadMessagesCounter }) => {
  const { t } = useI18n()

  return (
    <S.Header>
      {chatListIsOpen ? (
        <S.DisabledHeaderButton>{t('chat.title')}</S.DisabledHeaderButton>
      ) : (
        <S.BackToConversationsButton size="small" type="text" onClick={handleOpenChatList}>
          {t('chat.title')} {unreadMessagesCounter > 0 && <S.UnreadBadge>{unreadMessagesCounter}</S.UnreadBadge>}
        </S.BackToConversationsButton>
      )}

      {title && <FontAwesomeIcon icon={faChevronRight} style={{ opacity: 0.5 }} />}

      <S.HeaderTitle>{title}</S.HeaderTitle>
    </S.Header>
  )
}

ChatHeader.propTypes = {
  unreadMessagesCounter: PropTypes.number,
  handleOpenChatList: PropTypes.func.isRequired,
  title: PropTypes.string,
  chatListIsOpen: PropTypes.bool,
}

ChatHeader.defaultProps = {
  unreadMessagesCounter: 0,
  title: '',
  chatListIsOpen: false,
}

export default ChatHeader
